import { render, staticRenderFns } from "./CreateTask.vue?vue&type=template&id=27605101&"
import script from "./CreateTask.vue?vue&type=script&lang=ts&"
export * from "./CreateTask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports